<template>
    <vue-bootstrap-typeahead
        :data="stores"
        :serializer="s => s.company_name + ' - ' + s.name"
        @hit="selectedStore = $event"
        placeholder="Find a store..."
        v-model="storeSearch"
    ></vue-bootstrap-typeahead>
</template>

<script>
    const API_URL = 'https://api-url-here.com?query=:query'

    export default {
        name: 'TypeaheadSearch',

        props: ['searchUrl'],

        data() {
            return {
                stores: [],
                storeSearch: '',
                selectedStore: null
            }
        },

        methods: {
            async getStores(query) {
                if (query.length > 0) {
                    const res = await fetch(this.searchUrl.concat('/' + query))
                    this.stores = await res.json()
                }
            }
        },

        watch: {
            storeSearch: _.debounce(function (addr) {
                this.getStores(addr)
            }, 500)
        }
    }
</script>
